const indexItems = [
  { title: '明星塌房', desc: '最新明星翻车合集', icon: 'ri-alert-line', count: '128篇' },
  { title: '网红翻车', desc: '网红直播间名场面', icon: 'ri-live-line', count: '96篇' },
  { title: '聊天记录', desc: '独家私密对话曝光', icon: 'ri-chat-smile-2-line', count: '87篇' },
  { title: '综艺内幕', desc: '节目录制真实内幕', icon: 'ri-tv-line', count: '73篇' },
  { title: '影视泄密', desc: '未播片段抢先看', icon: 'ri-film-line', count: '65篇' },
  { title: '税务风波', desc: '艺人税务问题追踪', icon: 'ri-file-text-line', count: '54篇' },
  { title: '恋爱实锤', desc: '明星恋情实锤汇总', icon: 'ri-heart-line', count: '48篇' },
  { title: '合约纠纷', desc: '艺人经纪纠纷内幕', icon: 'ri-scales-line', count: '41篇' },
  { title: '行业深扒', desc: '娱乐圈操作全揭秘', icon: 'ri-search-eye-line', count: '36篇' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">内容导航</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">吃瓜目录</h2>
          <p className="text-foreground-600 text-sm mt-2">按分类浏览所有黑料内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg text-secondary-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}